import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import ReportsGrid from "./ReportsGrid";
import { useTabsStore } from "../../stores/TabsStore";
import { Button } from "../../ui/Button";


export default function ReportsMenu({onClose}:{onClose: () => void}) {
  let navigate = useNavigate()
  const { t } = useTranslation();
  const {setActiveTab} = useTabsStore()

  function allAnalytics() {
    onClose()
    setActiveTab(null)
    navigate("/analytics")
  }

  return (
      <>
        <div className="flex flex-row items-center px-2">
          <Button variant={"link"} onClick={() => allAnalytics()} className="text-base font-semibold flex h-14 items-center">{t("reports")}</Button>
        </div>
        <ReportsGrid onClose={onClose}/>
      </>
  )
} 